<template>
  <modal-popover id="new-token-modal"
                 title="SCIM Token"
                 data-testid="new-token-modal"
                 :displayed-id="modalDisplayedId"
                 @close-modal="closeTokenModal">
    <template v-slot:content>
      <atom-info-box priority="warning">
        Your new token will be shown only once. Make sure to copy and store it securely, as you won't be able to view
        it again.
      </atom-info-box>
      <molecule-card>
        <ion-data-items group-size="one">
          <ion-data-item item-key="Token">
            <span>{{ newToken }}</span>
          </ion-data-item>
        </ion-data-items>
        <div class="content-actions">
          <atom-button size="small" icon="copy" type="link-button" @click="copyToken">
            Copy to clipboard
          </atom-button>
        </div>
      </molecule-card>
    </template>
  </modal-popover>
</template>

<script lang="ts">
import AtomButton from "core/components/atom/button/AtomButton.vue";
import AtomInfoBox from "core/components/atom/infoBox/AtomInfoBox.vue";
import { useModalPopover } from "core/components/composable/modal-popover";
import IonDataItem from "core/components/ion/dataitems/IonDataItem.vue";
import IonDataItems from "core/components/ion/dataitems/IonDataItems.vue";
import ModalPopover from "core/components/ModalPopover.vue";
import MoleculeCard from "core/components/molecule/card/MoleculeCard.vue";
import showFlashMessage from "core/js/flashmessage/flash-message";
import { defineComponent } from "vue";

export default defineComponent({
  components: { ModalPopover, AtomButton, IonDataItem, IonDataItems, AtomInfoBox, MoleculeCard },
  props: {
    newToken: {
      type: String,
      required: true,
    },
  },
  emits: ["modal-closed"],
  setup() {
    const { modalDisplayedId, displayModal, closeModal } = useModalPopover();

    return {
      modalDisplayedId,
      displayModal,
      closeModal,
    };
  },
  created() {
    this.displayModal("new-token-modal");
  },
  methods: {
    async copyToken() {
      if (!navigator.clipboard || !this.newToken) {
        return;
      }
      try {
        await navigator.clipboard.writeText(this.newToken);
        showFlashMessage("Copied to clipboard");
      } catch (e) {
        console.error(e);
        showFlashMessage("Could not copy to clipboard", {
          displayType: "danger",
        });
      }
    },
    closeTokenModal() {
      this.closeModal();
      this.$emit("modal-closed");
    },
  },
});
</script>
